import { useIsMobile } from "hooks/useIsMobile";
import { useCallback, useRef } from "react";

export function useMobileScrollIntoView() {
  const { isMobile } = useIsMobile();
  const ref = useRef<HTMLDivElement>(null);

  const onClick = useCallback(() => {
    if (!isMobile) return;
    try {
      ref.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    } catch (error) {
      console.error(error);
    }
  }, [isMobile]);

  return { ref, onClick };
}
